import LedDiagram from "../../../../docs/_images/hw_ff_led.png";
import LedSchematics from "../../../../docs/_images/hw_ff_led_schem.png";
import PwmWiki from "../../../../docs/_images/pwm.png";
import * as React from 'react';
export default {
  LedDiagram,
  LedSchematics,
  PwmWiki,
  React
};